/* ALTF4 search & filtering behaviour — collection + /search.
 *
 * Progressive enhancement only. Every control this file touches is a real form control
 * inside a real GET form; with JS off, filtering, sorting and pagination all still work.
 * With JS on, applies re-render through the Section Rendering API instead of a full load.
 *
 * URL grammar is Shopify's own (filter.p.* / filter.v.* / q / type / sort_by / page).
 * We never invent params, and we never filter a result array client-side.
 */
(function () {
  'use strict';
  if (window.__af4FacetsBound) return;
  window.__af4FacetsBound = true;

  var DESKTOP = '(min-width: 990px)';
  var isDesktop = function () { return window.matchMedia(DESKTOP).matches; };

  function root() { return document.querySelector('[data-af4-results]'); }
  function sectionId() {
    var r = root();
    return r ? r.getAttribute('data-af4-section-id') : null;
  }

  /* ---------- URL building ---------- */

  function formToParams(form) {
    var params = new URLSearchParams();
    var fd = new FormData(form);
    fd.forEach(function (val, key) {
      if (val === null || val === undefined) return;
      if (String(val).trim() === '') return;   // empty price inputs must not appear
      params.append(key, val);
    });
    return params;
  }

  function urlFromForm(form) {
    var params = formToParams(form);
    params.delete('page');                     // any filter change resets pagination
    var qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  /* ---------- fetch + swap ---------- */

  var inflight = null;

  function render(url, opts) {
    opts = opts || {};
    var sid = sectionId();
    if (!sid) { window.location.href = url; return; }

    var target = root();
    if (target) target.setAttribute('aria-busy', 'true');

    if (inflight) inflight.abort();
    var ctrl = new AbortController();
    inflight = ctrl;

    var sep = url.indexOf('?') === -1 ? '?' : '&';
    fetch(url + sep + 'section_id=' + encodeURIComponent(sid), { signal: ctrl.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-af4-results]');
        var current = root();
        if (!fresh || !current) { window.location.href = url; return; }

        current.innerHTML = fresh.innerHTML;
        current.removeAttribute('aria-busy');

        if (opts.push !== false) {
          window.history.pushState({ af4: true }, '', url);
        }
        announce(current);
        if (opts.scroll) {
          var top = current.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
        autoloadArmed = true;
        observeSentinel();
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = url;            // never leave the shopper stuck
      });
  }

  function announce(scope) {
    var live = scope.querySelector('[data-af4-live]');
    var count = scope.querySelector('[data-af4-count]');
    if (live && count) live.textContent = count.textContent;
  }

  /* ---------- delegated events ---------- */

  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('[data-af4-facets]');
    if (form) {
      // Mobile batches behind Apply; desktop applies immediately.
      if (!isDesktop() && document.body.classList.contains('af4-sheet-open')) {
        previewCount(form);
        return;
      }
      e.preventDefault();
      render(urlFromForm(form));
      return;
    }
    var sort = e.target.closest && e.target.closest('[data-af4-sort]');
    if (sort) {
      e.preventDefault();
      var sf = sort.closest('form');
      if (sf) render(urlFromForm(sf));
    }
  });

  // Price inputs: apply on Enter / blur rather than on every keystroke.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var inp = e.target.closest && e.target.closest('.af4-facet__price input');
    if (!inp) return;
    e.preventDefault();
    var form = inp.closest('[data-af4-facets]');
    if (form && isDesktop()) render(urlFromForm(form));
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-af4-facets]');
    if (!form) return;
    e.preventDefault();
    render(urlFromForm(form));
    closeSheet();
  });

  document.addEventListener('click', function (e) {
    var t = e.target;

    // chip removal / clear-all — Shopify hands us a complete URL, just take it
    var nav = t.closest && t.closest('[data-af4-nav], [data-af4-clear]');
    if (nav && nav.getAttribute('href')) {
      e.preventDefault();
      render(nav.getAttribute('href'));
      return;
    }

    // show more / show less inside a facet group
    var more = t.closest && t.closest('[data-af4-more]');
    if (more) {
      e.preventDefault();
      var group = more.closest('.af4-facet');
      var expanded = group.classList.toggle('is-expanded');
      more.textContent = expanded ? more.getAttribute('data-less') : more.getAttribute('data-more');
      more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      return;
    }

    // load more
    var lm = t.closest && t.closest('[data-af4-loadmore]');
    if (lm) {
      e.preventDefault();
      loadMore(lm);
      return;
    }

    // pagination links inside the results region
    var pager = t.closest && t.closest('[data-af4-results] .af4-pager a');
    if (pager && pager.getAttribute('href')) {
      e.preventDefault();
      render(pager.getAttribute('href'), { scroll: true });
      return;
    }

    if (t.closest && t.closest('[data-af4-sheet-open]')) { e.preventDefault(); openSheet(); return; }
    if (t.closest && t.closest('[data-af4-sheet-close]')) { e.preventDefault(); closeSheet(); return; }
  });

  window.addEventListener('popstate', function () {
    render(window.location.pathname + window.location.search, { push: false });
  });

  /* ---------- mobile sheet ---------- */

  var lastFocus = null;

  function openSheet() {
    var sheet = document.querySelector('[data-af4-sheet]');
    if (!sheet) return;
    lastFocus = document.activeElement;
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    document.body.classList.add('af4-sheet-open');
    document.documentElement.style.overflow = 'hidden';
    var first = sheet.querySelector('button, [href], input, select');
    if (first) first.focus();
    document.addEventListener('keydown', sheetKeys);
  }

  function closeSheet() {
    var sheet = document.querySelector('[data-af4-sheet]');
    if (!sheet) return;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('af4-sheet-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', sheetKeys);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function sheetKeys(e) {
    if (e.key === 'Escape') { closeSheet(); return; }
    if (e.key !== 'Tab') return;
    var sheet = document.querySelector('[data-af4-sheet].is-open');
    if (!sheet) return;
    var f = sheet.querySelectorAll('button, [href], input:not([disabled]), select, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // Live count on the sheet's Apply button, without applying.
  var previewCtrl = null;
  function previewCount(form) {
    var sid = sectionId();
    var btn = form.querySelector('[data-af4-applycount]');
    if (!sid || !btn) return;
    if (previewCtrl) previewCtrl.abort();
    previewCtrl = new AbortController();
    var url = urlFromForm(form);
    fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sid), { signal: previewCtrl.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var c = doc.querySelector('[data-af4-count-n]');
        btn.textContent = c ? ' · ' + c.textContent.trim() : '';
      })
      .catch(function () { /* count preview is cosmetic — silence is correct */ });
  }

  /* ---------- infinite scroll ----------
     13 Sep 2026, April: "make it so the page keeps scrolling" — search results AND collection
     pages. Was "one automatic page, then click Load more" on search (collections had no load more
     at all since 10 Sep). Now the next page loads every time the invisible [data-af4-loadmore]
     marker under the grid comes within 300px of the viewport, until the last page. The numbered
     pager stays in the markup for no-JS visitors and crawlers; the `af4-infinite` class on <html>
     hides it (altf4-custom.css) only when this script can actually scroll-load. */

  var autoloadArmed = true;   // kept for render(): re-arming after a filter change is harmless now
  var observer = null;
  if ('IntersectionObserver' in window) document.documentElement.classList.add('af4-infinite');

  function loadMore(btn) {
    var url = btn.getAttribute('data-af4-url');
    if (!url || btn.hasAttribute('data-loading')) return;
    var sid = sectionId();
    if (!sid) { window.location.href = url; return; }
    btn.setAttribute('data-loading', '1');
    btn.setAttribute('aria-busy', 'true');

    fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sid))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshGrid = doc.querySelector('[data-af4-grid]');
        var grid = document.querySelector('[data-af4-grid]');
        if (!freshGrid || !grid) { window.location.href = url; return; }

        // Skip a card whose product is already on screen. Shopify's /search pages are not stable
        // across page requests (measured 13 Sep: pages 1-4 of "steam" repeat 4 products), and with
        // continuous scroll a repeat reads as a bug. Collections were not seen repeating; the check
        // is harmless there.
        var seen = {};
        Array.prototype.forEach.call(grid.querySelectorAll('a[href*="/products/"]'), function (a) {
          seen[a.getAttribute('href').split('?')[0]] = true;
        });
        while (freshGrid.firstElementChild) {
          var card = freshGrid.firstElementChild;
          var link = card.querySelector ? card.querySelector('a[href*="/products/"]') : null;
          var key = link ? link.getAttribute('href').split('?')[0] : null;
          if (key && seen[key]) { freshGrid.removeChild(card); continue; }
          if (key) seen[key] = true;
          grid.appendChild(card);
        }

        var freshBtn = doc.querySelector('[data-af4-loadmore]');
        if (freshBtn) {
          btn.setAttribute('data-af4-url', freshBtn.getAttribute('data-af4-url'));
          btn.removeAttribute('data-loading');
          btn.removeAttribute('aria-busy');
        } else if (btn.parentNode) {
          btn.parentNode.removeChild(btn);   // last page loaded — nothing left to fetch
        }
        window.history.replaceState({ af4: true }, '', url);
        observeSentinel();   // observe() reports straight away if the marker is still in view
      })
      .catch(function () { window.location.href = url; });
  }

  // Every time the marker nears the viewport, load the next page (until there is none).
  function observeSentinel() {
    if (observer) { observer.disconnect(); observer = null; }
    var btn = document.querySelector('[data-af4-loadmore]');
    if (!btn || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting || !observer) return;
        observer.disconnect();
        observer = null;
        loadMore(btn);
      });
    }, { rootMargin: '300px' });
    observer.observe(btn);
  }

  if (document.readyState !== 'loading') observeSentinel();
  else document.addEventListener('DOMContentLoaded', observeSentinel);
})();
